'use client'

import {Stack, Text} from '@blocks'

export const Where = () => {
   return (
      <Stack
         id={'why'}
         my={100}
         gap={20}
      >
         <Text
            c={'white'}
            fz={23}
            fw={650}
         >
            Where We’re Headed
         </Text>
         <Text
            c={'white'}
            fz={18}
         >
            Kodra is early, but deliberately so. Built on strong
            foundations and a growing network of collaborators, we’re
            focused on taking on meaningful work—partnering with
            people who care about what they’re building and how it’s
            delivered.
         </Text>
      </Stack>
   )
}
